// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';

const msid = '0d885237-6218-4657-bf80-625c39812592'; //replace the value between quotes with your site msid value

const biGroupsLoggers = {
    19: biLoggerFactory('get-started', 19, { msid }),
}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log(biEventObject)
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}